export default () => {
  return {
    indexWebViewPath: 'src/webviews/graph/index.html',
    questionnairesWebViewPath: 'src/webviews/questionnaires/index.html',
    localAssetsWebViewPath: 'src/webviews/',
  };
};
